import {toast, ToastContainer} from "react-toastify";
import {CommonService} from "../../services";


const AlertComponent = () => {

    return (
        <ToastContainer position={CommonService._alert.AlertPosition}/>
    )
};

export default AlertComponent;

const closeToast = () => {
    toast.dismiss();
};

export const AlertCloseButton = ({...props}: any) => {
    return <span className="toast-close-btn"
                 {...props}
                 id={"toast-close-btn"}
                 onClick={closeToast}
    >
        x
        {/*<ImageConfig.ToastCloseIcon/>*/}
    </span>
};
